// @ts-strict-ignore
import styled from "styled-components";

export const DynamicContainer = styled.div`
  background-color: ${({ theme }) => theme.colorPalette.gray[50]};
`;
